export const BLOG_HIGHLIGHTS = [
  {
    id: 1,
    title: 'Back-end',
    description: 'APIs, integracoes e boas praticas para manter sistemas saudaveis.',
  },
  {
    id: 2,
    title: 'Seguranca',
    description: 'Estudos de fundamentos, ferramentas e cuidados do dia a dia.',
  },
  {
    id: 3,
    title: 'Projetos',
    description: 'Aprendizados aplicados nos trabalhos que estou construindo.',
  },
];
